import { render, staticRenderFns } from "./BrandDetailsPopup.vue?vue&type=template&id=3b950ba8&scoped=true&"
import script from "./BrandDetailsPopup.vue?vue&type=script&lang=ts&"
export * from "./BrandDetailsPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b950ba8",
  null
  
)

export default component.exports